import React, { useState } from 'react';
import Logo from '@auth/common/logo';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, Container, Content, Title, Text, Info } from './styles';
import { OPENSOURCE } from '@auth/common/constants';
import auth from '@services/cognito';
import { UTM } from '@auth/common/util';
import useStores from '@stores/useStores';
import { getApiErrorMessage } from '@components/common/util/util';

interface Props {
  email: string;
  type: UTM;
}
export default ({ email, type }: Props) => {
  const { messagesStore } = useStores();
  const [disabled, setDisabled] = useState(false);

  const resendEmail = async () => {
    if (disabled) {
      return;
    }
    setDisabled(true);
    try {
      await auth.signupMail(email, type !== OPENSOURCE);
      messagesStore.showSuccessMessage('Email resent successfully');
    } catch (err) {
      messagesStore.showErrorMessage(getApiErrorMessage(err, 'Failed to resend email'));
    }
    setDisabled(false);
  };

  return (
    <>
      <Logo />
      <Container centered>
        <Content>
          <FontAwesomeIcon icon={faEnvelope} className="fa-3x" />
          <Title>Check your inbox</Title>
          <Info>
            We sent an email to {email}. Click on the link to set up your account and start doing
            more with your data.
          </Info>
          <Text>
            Didn’t get an email?{' '}
            <Link className="cursor-pointer" onClick={resendEmail}>
              Resend it
            </Link>
          </Text>
        </Content>
      </Container>
    </>
  );
};
